import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
const toFormattablePostalAddress = (param)=>{
    let { address1, address2, city, state, postalCode } = param;
    return {
        address1,
        address2,
        city,
        state,
        postalCode
    };
};
export const withDetailStatus = (status)=>(detail)=>_object_spread_props(_object_spread({}, detail), {
            status
        });
export const withSavedClientDetail = (param)=>{
    let { name, clientType, postalAddress, referenceFields } = param;
    return (detail)=>_object_spread(_object_spread_props(_object_spread({}, detail), {
            name,
            clientType
        }), postalAddress === undefined ? {} : {
            postalAddress: postalAddress == null ? null : toFormattablePostalAddress(postalAddress)
        }, referenceFields == null ? {} : {
            referenceFields
        });
};
